import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { initialCategoryTypeState } from "./categoryType.types";
import { categoryTypeActions } from ".";
import { CLEAR_CATGEORY_TYPE_STATE, FETCH_CATEGORY_TYPE_LIST_FAILED, FETCH_CATEGORY_TYPE_LIST_PROGRESS, FETCH_CATEGORY_TYPE_LIST_SUCCESS } from "./categoryTypeActions";

export const categoryTypeReducer = (
  state: IStoreState["categoryType"] = initialCategoryTypeState,
  action: categoryTypeActions
) => {
  switch (action.type) {
    case FETCH_CATEGORY_TYPE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
      });
      return newState;
    }
    case FETCH_CATEGORY_TYPE_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_CATEGORY_TYPE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
      });
      return newState;
    }
    case CLEAR_CATGEORY_TYPE_STATE: {
      return initialCategoryTypeState;
    }
    default:
      return state;
  }
};
